class FsProductCard extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("[data-fs-atc]");

    if (!this.button || this.button.dataset.bound) return;
    this.button.dataset.bound = "true";

    this.label = this.button.querySelector(".fs-atc-label");
    this.error = this.querySelector("[data-fs-atc-error]");
    this.defaultLabel = this.label.textContent.trim();
    this.available = !this.button.disabled;

    this.button.addEventListener("click", (event) => this.addToCart(event));

    this.select = this.querySelector("[data-fs-variant-select]");
    if (this.select) {
      this.price = this.querySelector("[data-fs-price]");
      this.comparePrice = this.querySelector("[data-fs-compare-price]");
      this.select.addEventListener("change", () => this.selectVariant());
    }
  }

  selectVariant() {
    const option = this.select.selectedOptions[0];
    this.available = option.dataset.available === "true";

    this.button.dataset.variantId = option.value;
    this.button.disabled = !this.available;
    this.defaultLabel = this.available
      ? this.dataset.addLabel
      : this.dataset.soldOutLabel;
    this.label.textContent = this.defaultLabel;

    if (this.price) this.price.textContent = option.dataset.price;

    if (this.comparePrice) {
      const compare = option.dataset.comparePrice;
      const onSale = compare && compare !== option.dataset.price;
      this.comparePrice.textContent = compare;
      this.comparePrice.hidden = !onSale;
    }
  }

  setLoading(isLoading) {
    this.button.disabled = isLoading || !this.available;
    this.button.classList.toggle("is-loading", isLoading);
  }

  showError(message) {
    this.error.textContent = message;
    this.error.hidden = false;
    setTimeout(() => (this.error.hidden = true), 4000);
  }

  async addToCart(event) {
    event.preventDefault();

    const cart = Alpine.store("xCartHelper");
    this.setLoading(true);

    try {
      await cart.waitForCartUpdate();
      window.updatingCart = true;

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [{ id: this.button.dataset.variantId, quantity: 1 }],
          sections: cart.getSectionsToRender().map(({ id }) => id),
        }),
      });
      const data = await response.json();

      if (!response.ok) throw new Error(data.description || Eurus.cart_error);

      await cart.reRenderSections(data.sections);
      cart.currentItemCount =
        parseInt(document.getElementById("cart-icon-bubble").textContent, 10) ||
        0;
      document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));

      Alpine.store("xMiniCart").openCart();

      this.label.textContent = this.button.dataset.addedLabel;
      setTimeout(() => (this.label.textContent = this.defaultLabel), 2000);
    } catch (error) {
      this.showError(error.message);
    } finally {
      window.updatingCart = false;
      this.setLoading(false);
    }
  }
}

if (!customElements.get("fs-product-card")) {
  customElements.define("fs-product-card", FsProductCard);
}
